export const formatPrice = (amount) =>
  new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
  })
    .format(amount)
    .replace(/\s?€/g, '€');

export const formatPercent = (value) =>
  new Intl.NumberFormat('es-ES', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
    .format(value)
    .replace(/\s?€/g, '%');
